export const COMPANY = {
  name: "Tomway s.r.o.",
  shop: "RareCandy.sk",
  street: "Družstevná 35",
  cityZip: "900 21 Svätý Jur",
  country: "Slovenská republika",
  ico: "44888684",
  icdph: "SK2022858959",
  email: "info@rarecandy.sk",
  phone: "+421 950 44 33 79",
  register: "OR Mestského súdu Bratislava III, oddiel Sro, vložka č. 59636/B",
};

export const TODO = "[ÚDAJ NA DOPLNENIE]";
